import { styled } from '@linaria/react';
import chroma from 'chroma-js';

import { range } from '@/utils';

import Demo, {
  DemoSliderControl,
  DemoRadioControl,
} from '@/components/Demo';

function ManuallyCalculateMidpoints({
  from = '#FFFF00',
  to = '#0005FF',
}) {
  return (
    <Demo
      id="manual-calculating-midpoints"
      initialValues={{ numMidpoints: 1, colorMode: 'rgb' }}
      controls={[
        <DemoSliderControl
          key="numMidpoints"
          id="numMidpoints"
          label="Number of Midpoints"
          min={0}
          max={16}
        />,
        <DemoRadioControl
          key="colorMode"
          id="colorMode"
          label="Color Mode"
          options={['rgb', 'hsl', 'lab', 'hcl']}
        />,
      ]}
    >
      {({ numMidpoints, colorMode }) => {
        const totalNumOfColors = numMidpoints + 2;
        const scale = chroma.scale([from, to]).mode(colorMode);

        return (
          <Wrapper>
            {range(totalNumOfColors).map((index) => {
              const color = scale(
                index / (totalNumOfColors - 1)
              ).hex();

              return (
                <ColorBox
                  key={index}
                  style={{ backgroundColor: color }}
                />
              );
            })}
          </Wrapper>
        );
      }}
    </Demo>
  );
}

const Wrapper = styled.div`
  display: flex;
  gap: 2px;
  width: 100%;
`;

const ColorBox = styled.div`
  height: 50px;
  flex: 1;
`;

export default ManuallyCalculateMidpoints;
